import { FormChildProps } from '../../types/FormChildProps';
import { InputEmail } from '../shared/inputs/InputEmail';
import { InputText } from '../shared/inputs/InputText';

export function FormInputs(props: FormChildProps) {
  return (
    <>
      {' '}
      <InputText
        required={true}
        label={'DNI'}
        name={'dni' + props.index}
        formRegister={props.register}
        maxLength={30}
        minLength={3}
        errorCollection={props.errors}
        onlyNumbers={true}
      />
      <InputText
        required={true}
        label="Nombre y apellido"
        name={'nombre' + props.index}
        formRegister={props.register}
        maxLength={50}
        minLength={1}
        errorCollection={props.errors}
      />
      <InputEmail
        required={true}
        label="Correo electrónico"
        name={'email' + props.index}
        formRegister={props.register}
        maxLength={50}
        minLength={1}
        errorCollection={props.errors}
      />
    </>
  );
}
